import React from 'react';
import clsx from 'clsx';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  headshotUpload: {
    transitionProperty: 'box-shadow',
    transitionDuration: theme.transitions.duration.short,
    transitionTimingFunction: theme.transitions.easing.easeInOut
  }
}));

function MarketingTab({ form, handleChange, setInForm }) {
  const classes = useStyles();

  const handleHeadshotChange = e => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = () => {
      const dataUri = `data:${file.type};base64,${btoa(reader.result)}`;
      setInForm('professionalHeadshot', dataUri);
    };
    reader.onerror = () => console.error('Error uploading headshot');
  };

  // The base64 value wins when present — it is what was just uploaded here. The
  // signed URL covers profiles whose headshot came in through an onboarding form
  // and lives in R2, which nothing used to render.
  const headshotPreview = form.professionalHeadshot || form.professionalHeadshotUrl;

  return (
    <div>
      <Typography variant="h6" className="mb-16">
        Marketing Information
      </Typography>

      <Typography variant="subtitle1" className="mb-8" style={{ fontWeight: 600 }}>
        Professional Headshot
      </Typography>
      <div className="mb-24">
        {headshotPreview && (
          <div
            className={clsx(classes.headshotUpload, 'w-128 h-128 rounded-8 mb-16 overflow-hidden shadow-1')}
            style={{
              backgroundImage: `url(${headshotPreview})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          />
        )}
        <label
          htmlFor="headshot-file"
          className={clsx(
            classes.headshotUpload,
            'flex items-center justify-center relative w-48 h-48 rounded-8 overflow-hidden cursor-pointer shadow-1 hover:shadow-5'
          )}
        >
          <input accept="image/*" className="hidden" id="headshot-file" type="file" onChange={handleHeadshotChange} />
          <Icon fontSize="large" color="action">
            cloud_upload
          </Icon>
        </label>
      </div>

      <TextField
        fullWidth
        multiline
        rows={5}
        className="mt-8 mb-24"
        id="professionalBio"
        name="professionalBio"
        label="Professional Bio"
        variant="outlined"
        value={form.professionalBio || ''}
        onChange={handleChange}
      />

      <Typography variant="h6" className="mb-16">
        Social Media Outlets
      </Typography>

      <TextField
        fullWidth
        className="mt-8 mb-16"
        id="linkedIn"
        name="linkedIn"
        label="LinkedIn"
        placeholder="https://linkedin.com/in/username"
        variant="outlined"
        value={form.linkedIn || ''}
        onChange={handleChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon>link</Icon>
            </InputAdornment>
          )
        }}
      />

      <TextField
        fullWidth
        className="mt-8 mb-16"
        id="facebook"
        name="facebook"
        label="Facebook"
        placeholder="https://facebook.com/username"
        variant="outlined"
        value={form.facebook || ''}
        onChange={handleChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon>link</Icon>
            </InputAdornment>
          )
        }}
      />

      <TextField
        fullWidth
        className="mt-8 mb-16"
        id="instagram"
        name="instagram"
        label="Instagram"
        placeholder="https://instagram.com/username"
        variant="outlined"
        value={form.instagram || ''}
        onChange={handleChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon>link</Icon>
            </InputAdornment>
          )
        }}
      />

      <TextField
        fullWidth
        className="mt-8 mb-16"
        id="twitter"
        name="twitter"
        label="X (Twitter)"
        placeholder="https://x.com/username"
        variant="outlined"
        value={form.twitter || ''}
        onChange={handleChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon>link</Icon>
            </InputAdornment>
          )
        }}
      />

      <TextField
        fullWidth
        className="mt-8 mb-16"
        id="youtube"
        name="youtube"
        label="YouTube"
        placeholder="https://youtube.com/@channel"
        variant="outlined"
        value={form.youtube || ''}
        onChange={handleChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon>link</Icon>
            </InputAdornment>
          )
        }}
      />

      <TextField
        fullWidth
        className="mt-8 mb-16"
        id="tiktok"
        name="tiktok"
        label="TikTok"
        placeholder="https://tiktok.com/@username"
        variant="outlined"
        value={form.tiktok || ''}
        onChange={handleChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon>link</Icon>
            </InputAdornment>
          )
        }}
      />
    </div>
  );
}

export default MarketingTab;
